import I18n from "i18n-js";
import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, View } from "react-native";

import DoctorField from "./DoctorField";

export default class DoctorDetailMore extends React.Component {
  static propTypes = {
    education: PropTypes.string.isRequired,
    hospital: PropTypes.string.isRequired,
    practiceLicense: PropTypes.string.isRequired,
    registrationCertificate: PropTypes.string.isRequired
  };

  render() {
    const {
      education,
      hospital,
      practiceLicense,
      registrationCertificate
    } = this.props;

    return (
      <View style={styles.container}>
        <DoctorField
          label={I18n.t("prixa.registrationCertificate")}
          value={registrationCertificate}
        />
        <DoctorField
          label={I18n.t("prixa.practiceLicense")}
          value={practiceLicense}
        />
        <DoctorField label={I18n.t("prixa.education")} value={education} />
        <DoctorField label={I18n.t("prixa.hospital")} value={hospital} />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    padding: 30
  }
});
